import { Card, CardContent, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import { IDataDetalharCooperado } from '../../../../../../../types/api/cadastros/detalhar-cooperado';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import DialogEditarCompradorAutorizado from './components/DialogEditarCompradorAutorizado';
import { formatarCPFCNPJ, formatarTelefone } from '../../../../../../../helpers/masks';
import DialogIncluirCompradorAutorizado from './components/DialogInclurCompradorAutorizado';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useMutation, useQueryClient } from 'react-query';
import axiosClient from '../../../../../../../lib/axios';
import { useSnackbar } from 'notistack';
import TrashIcon from '@mui/icons-material/Delete';

interface PropsCardCompradoresAutorizados {
  data: IDataDetalharCooperado;
}

export default function CardCompradoresAutorizados({
  data
}: PropsCardCompradoresAutorizados) {

  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [selectedRelacionamento, setSelectedRelacionamento] = useState(null);
  const [includeModalOpen, setIncludeModalOpen] = useState<boolean>(false);

  const handleEdit = (relacionamento: any) => {
    setSelectedRelacionamento(relacionamento);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedRelacionamento(null);
  };
  const handleInclude = () => {
    setIncludeModalOpen(true);
  };

  const handleCloseIncludeModal = () => {
    setIncludeModalOpen(false);
  };

  const { mutate: deleteRelacionamento } = useMutation({
    mutationFn: (id: string) => axiosClient.delete(`cadastros/excluir-comprador/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries('cadastros/detalhar-cooperado')
      enqueueSnackbar("Relacionamento excluído com sucesso!", { variant: "success" });
    },
  });

  const handleDelete = (id: number) => {
    deleteRelacionamento(id.toString());
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" mb={2}>
          Compradores Autorizados
        </Typography>
        <TableContainer>
          <Table size="small" aria-label="tabela simples">
            <TableHead>
              <TableRow>
                <TableCell><b>Nome</b></TableCell>
                <TableCell><b>Documento</b></TableCell>
                <TableCell><b>Telefone</b></TableCell>
                <TableCell><b>Tipo Relacionamento</b></TableCell>
                <TableCell><b></b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.compradores_autorizados.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.nome || 'Não informado'}
                  </TableCell>
                  <TableCell>
                    {formatarCPFCNPJ(row.documento) || 'Não informado'}
                  </TableCell>
                  <TableCell>
                    {formatarTelefone(row.telefone) || 'Não informado'}
                  </TableCell>
                  <TableCell>
                    {row.tipo_relacionamento || 'Não informado'}
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Editar Comprador Autorizado">
                      <IconButton
                        onClick={() => handleEdit(row)}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir Comprador Autorizado">
                      <IconButton
                        onClick={() => handleDelete(row.id)}
                      >
                        <TrashIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleInclude}
            size="small"
          >
            Adicionar
          </Button>
        </div>
      </CardContent>
      <DialogIncluirCompradorAutorizado
        open={includeModalOpen}
        onClose={handleCloseIncludeModal}
        cooperadoId={data.id}
      />
      <DialogEditarCompradorAutorizado
        open={editModalOpen}
        onClose={handleCloseEditModal}
        data={selectedRelacionamento}
        cooperadoId={data.id}
      />

    </Card>
  )
}